interface EngoLogoProps {
  size?: number;
  className?: string;
}

export function EngoLogo({ size = 32, className }: EngoLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Engo"
    >
      <rect width="32" height="32" rx="8" fill="#4F46E5" />
      <rect x="9" y="8" width="3.5" height="16" rx="1.75" fill="white" />
      <rect x="9" y="8" width="12" height="3.5" rx="1.75" fill="white" />
      <rect x="9" y="14.25" width="9" height="3.5" rx="1.75" fill="white" />
      <rect x="9" y="20.5" width="12" height="3.5" rx="1.75" fill="white" />
    </svg>
  );
}
